import { cx } from "@emotion/css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { AuthenticatedLayout } from "@/layouts/AuthenticatedLayout/AuthenticatedLayout";
import { SignOutDialog } from "@/modules/auth/components/SignOutDialog/SignOutDialog";
import { useAuthContext } from "@/modules/auth/hooks/useAuthContext";
import { authenticatedRouting } from "@/modules/router/routings/authenticatedRouting";
import { PageMeta } from "@/modules/theme/components/PageMeta";
import { Typography } from "@/modules/theme/components/Typography/Typography";
import { useTheme } from "@/modules/theme/hooks/useTheme";

import { createMoreMenuPageStyles } from "./createMoreMenuPageStyles";

const translationNamespace = "pages/MoreMenuPage";

export const MoreMenuPage = () => {
  const { t } = useTranslation(translationNamespace);
  const classes = createMoreMenuPageStyles(useTheme());
  const { hasAdminPrivilages } = useAuthContext();

  const [isSignOutDialogOpen, setIsSignOutDialogOpen] = useState(false);

  return (
    <AuthenticatedLayout>
      <>
        <PageMeta title={t("More")} />
        <Typography variant="pageHeading">{t("More")}</Typography>
        <nav className={classes.nav}>
          <ul>
            {hasAdminPrivilages ? (
              <li className={classes.navItem}>
                <Link
                  to={authenticatedRouting.buildUrl("handbooks")}
                  className={classes.link}
                >
                  {t("Handbooks")}
                </Link>
              </li>
            ) : null}
            <li className={classes.navItem}>
              <Link
                to={authenticatedRouting.buildUrl("changePassword")}
                className={classes.link}
              >
                {t("Change Password")}
              </Link>
            </li>
            <li className={classes.navItem}>
              <button
                className={cx(classes.button, classes.link)}
                onClick={() => setIsSignOutDialogOpen(true)}
              >
                {t("Log out")}
              </button>
            </li>
          </ul>
        </nav>
      </>
      <SignOutDialog
        isOpen={isSignOutDialogOpen}
        onClose={() => setIsSignOutDialogOpen(false)}
      />
    </AuthenticatedLayout>
  );
};
